import { FC } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { checkIsActive, KTIcon } from '../../../../helpers'
import { useAuth } from '../../../../../app/modules/auth'

type Props = {
  to: string
  title: string
  title2: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
}

const MenuItem: FC<Props> = ({ to, title, title2, icon, fontIcon, hasArrow = false, hasBullet = false }) => {
  const { pathname } = useLocation()
  const { currentUser } = useAuth() as { currentUser: any };
  console.log(currentUser.userType);

  return (
    <div className='menu-item me-lg-1'>
      <Link
        className={clsx('menu-link py-3', {
          'active menu-here': checkIsActive(pathname, to),
        })}
        to={to}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        {/* <span className='menu-title'>{title}</span> 
        <span className='menu-title'>{title2}</span> */}


        <div className='d-flex flex-column'>
          <span className='menu-title'>{title}</span>
          {currentUser?.userType !== 'RECYCLER' && (
            <span className='menu-title'>{title2}</span>
          )}
        </div>


        {hasArrow && <span className='menu-arrow'></span>}
      </Link>
    </div>
  )
}

export { MenuItem }
